import { render } from "./TipForm.vue?vue&type=template&id=fd70d15c"
import script from "./TipForm.vue?vue&type=script&lang=js"
export * from "./TipForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__